export const environment = {
  production: true,
  api_base_url: "https://st-crm-api.elmasriagroupco.com/api/",
  api_raw_base_url: "https://st-crm-api.elmasriagroupco.com/",
  base_url: "https://st-crm.elmasriagroupco.com",
  baseHREF: "/",
  firebase: {
    apiKey: "AIzaSyCrAexwe5SimwMduWE516yMdYxrgjL1VN0",
    authDomain: "masris-group.firebaseapp.com",
    projectId: "masris-group",
    storageBucket: "masris-group.appspot.com",
    messagingSenderId: "959098777096",
    appId: "1:959098777096:web:6476ae65e015497c52abbd",
    vapidKey:
      "BEZk-T6SoJhIaUitrM8wsAnzQQdJLzioMrSIKgftKSm14lr5XNNsiN9wRqnnB_5AbETldi-vSPNxWVveC9DQ99M",
  },
  statics: {
    projectName: "masria group co",
  },
};

// /home/admin/web/staging2.fabrica-dev.com/ssh-ali

//scp -i /home/admin/web/staging2.fabrica-dev.com/ssh-ali/Staging.pem -r * ubuntu@3.138.111.226:/var/www/html/castle-backend/public/uploads



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts